import { render, staticRenderFns } from "./AccountRegisterDone.vue?vue&type=template&id=58f9f138"
import script from "./AccountRegisterDone.vue?vue&type=script&lang=js"
export * from "./AccountRegisterDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports